"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationGraph = void 0;
exports.getLocationGraphForAdventure = getLocationGraphForAdventure;
exports.getRandomElement = getRandomElement;
const GAME_MECHANICS_ADJACENCY = {
    building_corridor: [
        'cafeteria',
        'schedule_board',
        'mail_room',
        'locker_room',
        'exit',
        'level_2_corridor'
    ],
    cafeteria: ['building_corridor'],
    schedule_board: ['building_corridor'],
    mail_room: ['building_corridor'],
    locker_room: ['building_corridor'],
    exit: ['building_corridor'],
    level_2_corridor: ['building_corridor', 'timing_lab', 'robots_lab'],
    timing_lab: ['level_2_corridor'],
    robots_lab: ['level_2_corridor']
};
function normalizeAdjacencyMap(map) {
    const result = new Map();
    const ensure = (k) => {
        const existing = result.get(k);
        if (existing)
            return existing;
        const created = new Set();
        result.set(k, created);
        return created;
    };
    for (const [from, tos] of Object.entries(map)) {
        const fromSet = ensure(from);
        for (const to of tos || []) {
            if (!to || to === from)
                continue;
            fromSet.add(to);
            ensure(to).add(from);
        }
    }
    const out = new Map();
    for (const [k, set] of result.entries()) {
        out.set(k, Array.from(set).sort((a, b) => a.localeCompare(b)));
    }
    return out;
}
/**
 * Reusable undirected location graph helper.
 */
class LocationGraph {
    constructor(map) {
        this.adjacency = normalizeAdjacencyMap(map);
    }
    /** Returns a sorted list of neighbors. Unknown locations return []. */
    getAdjacentLocations(locationId) {
        if (!locationId)
            return [];
        return [...(this.adjacency.get(locationId) || [])];
    }
}
exports.LocationGraph = LocationGraph;
const graphRegistry = new Map([
    ['game-mechanics', new LocationGraph(GAME_MECHANICS_ADJACENCY)]
]);
/**
 * Resolve an adventure-specific graph. Unknown adventures currently return `undefined`.
 */
function getLocationGraphForAdventure(adventureId) {
    return graphRegistry.get(adventureId);
}
/** Script-friendly utility used by NPC update logic. */
function getRandomElement(items) {
    if (!Array.isArray(items) || items.length === 0)
        return undefined;
    const index = Math.floor(Math.random() * items.length);
    return items[index];
}
//# sourceMappingURL=LocationGraph.js.map